<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="image" slot-scope="data">
            <div v-if="!data.item.detailsShowing">
                <div v-if="!data.item.image"> --Sin imagen --</div>
                <b-button v-else size="sm"  :disabled="!data.item.image" @click.stop="data.toggleDetails" variant="primary"><i class="fa fa-picture-o"></i></b-button>
            </div>
            <b-button size="sm" v-else variant="danger" @click.stop="data.toggleDetails">Cerrar</b-button>
        </template>

            <template slot="row-details" slot-scope="data">
                <div class="d-flex justify-content-center">
                    <div class="w-50">
                        <div v-if="isPdf(data.item.image)">
                            <embed :src="data.item.image" width="500" height="375" type="application/pdf">
                        </div>
                        <div v-else>
                            <b-carousel id="carousel1"
                                style="text-shadow: 1px 1px 2px #333;"
                                controls
                                indicators
                                background="#ababab"
                                :interval="4000"
                                img-width="350px"
                                img-height="200px"
                            >
                            <b-carousel-slide img-height="200" :img-src="data.item.image"
                        ></b-carousel-slide>
                        </b-carousel>
                        </div>

                    </div>
                </div>
            </template>

        <template slot="actions" slot-scope="{ item }">
            <b-btn variant="primary" size="sm" @click="$emit('showAccuses', item)"><i class="fa fa-thumbs-up"></i></b-btn>
            <b-btn variant="danger" size="sm" @click="removeAlert(item)"><i class="fa fa-trash"></i></b-btn>
            <b-btn variant="primary" size="sm" target="_blank" :href="`/exports/alert-notification-statistics/export-excel?id=${item.id}`"><i class="fa fa-bar-chart-o"></i></b-btn>
        </template>
    </app-data-table>
</template>
<script>
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        removeAlert(data){
            this.$emit('remove-alert', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
        isPdf(uri) {
            return uri.endsWith('.pdf')
        }
    }
}

const fields = [
                    {
                        key: 'created_by.name',
                        label: 'Creador',
                        filter: true
                    },
                    {
                        key: 'title',
                        label: 'Titulo',
                        filter: true
                    },
                    {
                        key: 'description',
                        label: 'Descripción',
                        filter: true
                    },
                    {
                        key: 'profiles',
                        label: 'Perfiles',
                        filter: true
                    },
                    {
                        key: 'cities',
                        label: 'Ciudades',
                        filter: true
                    },
                    {
                        key: 'start_date',
                        label: 'Fecha inicio',
                        filter: true
                    },
                    {
                        key: 'end_date',
                        label: 'Fecha fin',
                        filter: true
                    },
                    {
                        key: 'image',
                        label: 'Imagen',
                        sortable: false
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ];
</script>
